
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'แหล่งข้อมูล',
	'dataSourceId': 'Id',
	'dataSourceType': 'ชนิด',
	'dataSourceName': 'ชื่อ',
	'dataSourcePath': 'พาธ',
	'showInfoForAll': 'แสดงระยะเวลาสำหรับวิชวลไลเซชันทั้งหมดs',
	'hideInfoForAll': 'ซ่อนระยะเวลาสำหรับวิชวลไลเซชันทั้งหมดs',
	'showPerformanceDetails': 'รันวิดเจ็ตทั้งหมดใหม่เพื่อรวมรายละเอียดด้านประสิทธิภาพ',
	'slotMappingField': 'การแม็พสล็อต',
	'slotDataMapping': 'การแม็พ',
	'slotID': 'ID',
	'slotCaption': 'คำบรรยาย',
	'slotMandatory': 'บังคับ',
	'slotIsMandatory': 'ใช่',
	'slotIsNotMandatory': 'ไม่',
	'infoNotAvailable': 'ไม่มีอยู่',
	'performanceSection': 'ประสิทธิภาพ',
	'durationField': 'ระยะเวลา',
	'singleQueryTime': 'เคียวรีเซิร์ฟเวอร์ (ms)',
	'multipleQueryTime': 'เคียวรีเซิร์ฟเวอร์ %{name} (ms)',
	'liveWidgetTotalTime': 'ทั้งหมด (ms)',
	'renderTimeNotAvailable': 'ไม่พร้อมใช้งาน',
	'renderInProgress': '(กำลังดำเนินการ)',
	'interactToTriggerQuery': 'โต้ตอบกับวิดเจ็ตเพื่อทริกเกอร์เคียวรี',
	'fetchQuery': 'ดึงข้อมูลเคียวรี',
	'showSQLMDX': 'แสดง SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'ข้อมูลเคียวรี',
	'queryInfoNotAvailable': 'ไม่มีข้อมูลเคียวรี',
	'query': 'เคียวรี',
	'copy': 'คัดลอก',
	'close': 'ปิด'
});
